import { Card, CardContent, Grid, Skeleton, Typography } from '@mui/material'

const LABELS = ['Low', 'Medium', 'Critical']
const COLORS = ['warning.main', 'warning.dark', 'error.main']
export const AlertCard = ({
  severity,
  count,
  isLoading = false,
}: {
  severity: number
  count: number
  isLoading?: boolean
}) => {
  return (
    <Grid item xs={12} md={4}>
      <Card elevation={0} variant="outlined">
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {LABELS[severity - 1]} Severity
          </Typography>
          {isLoading ? (
            <Skeleton variant="text" width={56} height={44} />
          ) : (
            <Typography variant="h4" color={COLORS[severity - 1]}>
              {count}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
  )
}
